/* Stifler Craciun LP - comportament comun. Merge si in editorul de tema. */
(function(){
  if (window.__xlLoaded) return; window.__xlLoaded = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function pad(x){ return String(x).padStart(2,'0'); }

  function countdowns(scope){
    scope.querySelectorAll('[data-xl-cd]:not([data-ready])').forEach(function(el){
      el.setAttribute('data-ready','1');
      var mode = el.dataset.mode, mins = +el.dataset.minutes || 60, end;
      if (mode === 'date') { end = new Date(el.dataset.end).getTime(); }
      function target(){
        if (mode === 'date') return end;
        if (mode === 'midnight'){ var e = new Date(); e.setHours(24,0,0,0); return e.getTime(); }
        var k = 'xl_end_' + mins, v = 0;
        try { v = +localStorage.getItem(k) || 0; } catch(e){}
        if (!v || v < Date.now()){ v = Date.now() + mins*60000; try{ localStorage.setItem(k, v); }catch(e){} }
        return v;
      }
      var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function tick(){
        var left = Math.max(0, Math.floor((target() - Date.now())/1000));
        if (d) d.textContent = pad(Math.floor(left/86400));
        if (h) h.textContent = pad(Math.floor(left%86400/3600));
        if (m) m.textContent = pad(Math.floor(left%3600/60));
        if (s) s.textContent = pad(left%60);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  function tabs(scope){
    scope.querySelectorAll('[data-xl-tabs]:not([data-ready])').forEach(function(box){
      box.setAttribute('data-ready','1');
      var btns = box.querySelectorAll('[role="tab"]');
      btns.forEach(function(b, i){
        b.addEventListener('click', function(){ select(i); });
        b.addEventListener('keydown', function(e){
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft'){
            e.preventDefault();
            var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + btns.length) % btns.length;
            select(n); btns[n].focus();
          }
        });
      });
      function select(i){
        btns.forEach(function(b, j){
          var on = i === j;
          b.setAttribute('aria-selected', on); b.tabIndex = on ? 0 : -1;
          var p = document.getElementById(b.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      }
    });
  }

  var toast;
  function showToast(msg){
    if (!toast){
      toast = document.createElement('div'); toast.className = 'xl-toast'; toast.setAttribute('role','status');
      toast.innerHTML = '<span data-msg></span><a href="' + root + 'cart">Vezi cosul</a>';
      document.body.appendChild(toast);
    }
    toast.querySelector('[data-msg]').textContent = msg;
    toast.classList.add('show');
    clearTimeout(toast._t); toast._t = setTimeout(function(){ toast.classList.remove('show'); }, 4500);
  }

  function refreshCartCount(){
    fetch(root + 'cart.js').then(function(r){ return r.json(); }).then(function(c){
      document.querySelectorAll('[data-cart-count],.cart-count-bubble span,.cart-count,#CartCount,.header__cart-count').forEach(function(el){
        if (el.children.length === 0) el.textContent = c.item_count;
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: c }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function(){});
  }

  document.addEventListener('submit', function(e){
    var f = e.target.closest('[data-xl-add]'); if (!f) return;
    if (f.dataset.go === 'checkout') return; // trimitere normala, merge la checkout
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]'), txt = btn ? btn.innerHTML : '';
    if (btn){ btn.disabled = true; btn.textContent = 'Se adauga...'; }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, j: j }; }); })
      .then(function(res){
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Eroare');
        showToast('🎁 Adaugat in cos!'); refreshCartCount();
      })
      .catch(function(err){ showToast(err.message || 'Nu am putut adauga produsul'); })
      .finally(function(){ if (btn){ btn.disabled = false; btn.innerHTML = txt; } });
  });

  function sticky(){
    var st = document.querySelector('[data-xl-sticky]');
    if (!st || st.dataset.ready) return; st.dataset.ready = '1';
    var after = +st.dataset.after || 600;
    function on(){ st.classList.toggle('show', window.scrollY > after); }
    window.addEventListener('scroll', on, { passive: true }); on();
  }

  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href^="#"]'); if (!a || a.getAttribute('href').length < 2) return;
    var t = document.querySelector(a.getAttribute('href')); if (!t) return;
    e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  function init(scope){ scope = scope || document; countdowns(scope); tabs(scope); sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); }); else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
